module.exports = __webpack_public_path__ + "static/img/report.31b6a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/report.png
// module id = 0ZAh
// module chunks = 1